export function loadPermissionBaseUrl() {
        const appName = window.sidekick.store.get('passport').appShortName.toLowerCase();
        let buildConfig = window.buildConfig;
        return buildConfig.endpoint[appName].permissions;
}

export function getAppBaseUrl(){
	const { isMorpheus } = window.buildConfig;
	const segments = window.location.pathname.split('/').filter(segment => segment);
	// if we are in morpheus, we need to get the app base url and check if it has an app or service in the path
	// then we need to get the first two segments otherwise blank
	// Added similar logic in the router.js, auth.js in angular framework and in Supersuit-Jarvis
	const appBaseUrl = segments.length >= 3 && isMorpheus && (segments[0] === 'app' || segments[0] === 'service') ? segments.slice(0, 2).join('/') : '';
	return appBaseUrl;
}
